import { getEnvVar } from '@sh4res/bo-common/utils/env';

const getApiOrigin = (): string => getEnvVar('REACT_APP_API_ORIGIN') || window.origin;

export const getApiUrl = (): string => `${getApiOrigin()}/any/apibo_external`;
